<template>
  <game-base>
    <template v-slot:activity-fullscreen>
      <carousel ref="carouselGame" class="carousel" custom-btns is-cyclical>
        <slide-item
          v-for="(slide, key) in slides"
          :key="'slide_' + key"
          class="slides"
          :style="currentSlide && slideBaseBgImage"
        >
          <keep-alive>
            <component
              :is="slide.component"
              @on-next-slide="onNextSlide"
              @on-slide-data="onSlideData"
            />
          </keep-alive>
        </slide-item>
      </carousel>
    </template>
  </game-base>
</template>

<script>
import {
  computed,
  nextTick,
  onUnmounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { Carousel, SlideItem } from '@discoveryeducation/components';
import GameBase from '@/components/game/GameBase';
import * as componentSlides from '@/components/slides';

export default {
  name: 'GamePage',
  components: {
    GameBase,
    Carousel,
    SlideItem,
    ...componentSlides,
  },
  setup(_, { root }) {
    const { data, getAudioById, getImageById } = root;
    const carouselGame = ref(null);
    const currentSlide = ref(null);
    const slides = reactive(data.slides);

    const onSlideData = async (slideData) => {
      currentSlide.value = slideData;
      await nextTick();
    };

    const onNextSlide = () => {
      carouselGame.value.next();
    };

    const slideBaseBgImage = computed(() => ({
      backgroundImage: `url(${getImageById(currentSlide.value.imageId)})`,
    }));

    onUnmounted(() => getAudioById('bg-sound').stop());

    return {
      carouselGame,
      slides,
      currentSlide,
      onSlideData,
      onNextSlide,
      slideBaseBgImage,
    };
  },
};
</script>

<style lang="stylus" scoped>
.carousel, .carousel .slides
  height: 100%

  ::v-deep
    .carousel
      height 100%
</style>
